import { Button } from '@material-ui/core';
import React from 'react';
import { IconWithTooltip } from '../icons/IconWithTooltip';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';

export function GetAll({ getAllData }) {

    return (
        <IconWithTooltip title="Összes adat betöltése" >
            <Button className="material-action-icon-button" onClick={getAllData}>
                <AllInclusiveIcon className="material-action-icon" />
            </Button>
        </IconWithTooltip>
    )
}